// Composable de gating granular pela lista de permitted_keys do current user.
// Usado em menus, botões, sections - qualquer ponto da UI que precise esconder
// ou desabilitar funcionalidade conforme grupo de permissão do agente.
import { computed } from 'vue';
import { useStore } from 'dashboard/composables/store';

export const usePermissions = () => {
  const store = useStore();

  const currentUser = computed(() => store.getters.getCurrentUser);
  const accountId = computed(() => store.getters.getCurrentAccountId);

  const currentAccountUser = computed(() => {
    const accounts = currentUser.value?.accounts || [];
    return accounts.find(a => a.id === accountId.value);
  });

  const permittedKeys = computed(
    () => currentAccountUser.value?.permitted_keys || []
  );

  const isAdministrator = computed(
    () => currentAccountUser.value?.role === 'administrator'
  );

  const hasPermission = key => {
    if (isAdministrator.value) return true;
    return permittedKeys.value.includes(key);
  };

  const hasAnyPermission = keys => keys.some(k => hasPermission(k));

  const hasAllPermissions = keys => keys.every(k => hasPermission(k));

  return {
    isAdministrator,
    permittedKeys,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };
};
